'use client';

import { useEffect } from 'react';

export default function ErrorComponent({ error, reset }: { error: Error; reset?: () => void }) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div>
      <meta name="robots" content="noindex" />
      <h2>Something went wrong!</h2>
      {reset && (
        <button
          onClick={
            // Attempt to recover by trying to re-render the segment
            () => reset()
          }
        >
          Try again
        </button>
      )}
    </div>
  );
}
